"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyBodySchema = exports.PaginationQuerySchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.PaginationQuerySchema = zod_1.default.object({
    page: zod_1.default.coerce.number().min(1).default(1),
    pageSize: zod_1.default.coerce.number().default(12),
});
exports.EmptyBodySchema = zod_1.default.undefined();
